<template>
  <div class="author container">
    <div
      v-for="(item, index) in authorList" :key="index"
      class="author__row"
    >
      <div class="author__row__title">
        {{item.title}}
      </div>
      <div class="author__row__member-container">
        <div
          v-for="(item_m, index_m) in item.member" :key="index_m"
          class="author__row__member"
        >
          {{item_m}}
        </div>
      </div>
    </div>
    <div class="author__unit">{{org}}</div>
    <div class="author__date">{{date}}</div>
  </div>
</template>

<script>
export default {
  name: 'Author',
  props: {
    author: {
      type: Object,
    },
    org: {
      type: String,
    },
    date: {
      type: String,
    }
  },
  computed: {
    authorList() {
      return Object.values(this.author);
    }
  },
};
</script>

<style scoped lang="scss">
.author {
  margin-top: 30px;
  margin-bottom: 30px;
  color: #7b7a7a;
  font-size: 0.9rem;
  @media screen and (min-width: 1025px) {
    font-size: 1rem;
  }
  line-height: 1.7;
  .author__row {
    margin-bottom: 15px;
    display: flex;
    .author__row__title {
      position: relative;
      width: 37%;
      font-weight: bold;
      line-height: 1.3;
      text-align: left;
      @media screen and (min-width: 1025px) {
        width: 50%;
        text-align: right;
        padding-right: 10px;
      }
    }
    .author__row__member-container {
      width: 60%;
      padding-left: 20px;
      @media screen and (min-width: 1025px) {
        padding-left: 10px;
        width: 53%;
      }
    }
    .author__row__member {
      line-height: 1.3;
    }   
  }
  .author__unit {
    @media screen and (min-width: 1025px) {
      text-align: center;
    }
  }
  .author__date {
    @media screen and (min-width: 1025px) {
      text-align: center;
    }
  }
}
</style>
